<template>
  <section>
    <b-table
      :data="revenuesData"
      :columns="revenuesColumns"
      default-sort="shoppingCenterGroupName"
      default-sort-direction="asc"

    ></b-table>
  </section>
</template>
<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import revenueService from '@/services/revenueService';
import type { Section, Shop } from '@/stores/app';

interface MissingRevenueRow {
  shoppingCenterGroupName: string | undefined;
  shoppingCenterName: string | undefined;
  shopName: string;
  sectionName: string | undefined;
  shopDisabled: string;
}

type MissingRevenueShop = Shop & { sections?: Section[] };

export default defineComponent({
  props: {
    missingRevenues: {
      type: Array as PropType<MissingRevenueShop[]>,
      default: () => [],
    },
  },
  data() {
    return {
      revenuesColumns: [
        {
          field: 'shoppingCenterGroupName',
          label: this.$t('ShoppingCenterGroupName'),
          cellClass: 'has-text-right',
          sortable: true,
        },
        {
          field: 'shoppingCenterName',
          label: this.$t('ShoppingCenterName'),
          cellClass: 'has-text-right',
          sortable: true,
        },
        {
          field: 'shopName',
          label: this.$t('ShopName'),
          cellClass: 'has-text-right',
          sortable: true,
        },

        {
          field: 'sectionName',
          label: this.$t('SectionName'),
          cellClass: 'has-text-right',
          sortable: true,
        },
        {
          field: 'shopDisabled',
          label: this.$t('ShopDisabled'),
          cellClass: 'has-text-right',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    revenuesData(): MissingRevenueRow[] {
      return this.missingRevenues.flatMap((shop: MissingRevenueShop) =>
        (shop.sections ?? [])
          .filter(
            (section: Section) => revenueService.revenueExistsForShop(shop.shopId, section.sectionId)
                 === false
                && section.updateSucceed !== true,
          )
          .map((shopSection: Section) => ({
            shoppingCenterGroupName: shop.shoppingCenterGroupName,
            shoppingCenterName: shop.shoppingCenterName,
            shopName: shop.shopName,
            sectionName: shopSection.sectionName,
            shopDisabled: this.$t((shop.isDisabled ?? false).toString()),
          }))
      );
    },
  },
});
</script>
